<template>
  <CommonLayout header="ManagementHeader" footer="ManagementFooter">
    <div class="container">
      <div class="main-color text-light row mt-3">
        <div class="col p-2">
          納品画像登録
        </div>
      </div>
      <form method="post" action="#" class="form-horizontal">
        <div class="row base-color">
          <div class="col-sm-12 row p-3">
            <div class="col-sm-6">
              納品画像をセットし、登録してください。
            </div>
          </div>
          <div class="col-sm-12">
            <b-overlay :show="weddingInfoOverlayShow" rounded="sm">
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <td style="font-weight: 700" class="light-blue">案件No.</td>
                    <td colspan="11" style="font-weight: 700">{{weddingInfos.caseNumber}}</td>
                  </tr>
                  <tr>
                    <td class="light-blue">施設</td>
                    <td colspan="6">{{weddingInfos.facility}}</td>
                    <td colspan="2" class="light-blue">会場</td>
                    <td colspan="3">{{weddingInfos.venue}}</td>
                  </tr>
                  <tr>
                    <td class="light-blue">挙式日</td>
                    <td colspan="2">{{weddingInfos.weddingDate}}</td>
                    <td colspan="2" class="light-blue">披露宴時間</td>
                    <td colspan="2">{{weddingInfos.weddingTime}}</td>
                    <td colspan="2" class="light-blue">ご両家名</td>
                    <td colspan="3">{{weddingInfos.bothFamilyNames}}</td>
                  </tr>
                </tbody>
              </table>
            </b-overlay>
          </div>
          <b-overlay :show="overlayShow" rounded="sm">
            <div class="col-sm-12 row">
              <div class="col-sm-5 header-tile-image-dev">
                <div class="text-center" v-if="imageSelectNum in imageInfos && 'filePath' in imageInfos[imageSelectNum] && imageInfos[imageSelectNum].filePath">
                  <img :src="imageInfos[imageSelectNum].filePath" class="mw-100 header-tile-image-height">
                </div>
                <div class="text-center pt-5 border border-dark mh-300" v-else>
                  <p class="mt-5 pt-4">no Image</p>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="row">
                <div class="col-sm-6">
                  <div class="pr-2 pl-2">
                    <div>
                      <span class="delivery-text">スマートフォンから画像を登録する場合は<br>以下のQRコードを読み取ってください。</span>
                    </div>
                    <div>
                      <vue-qrcode class="ml-4" :value="qrImageUrl" :options="{
                        errorCorrectionLevel: 'M',
                        maskPattern: 0,
                        margin: 10,
                        scale: 2,
                        width: 200,
                        color: {
                          dark: '#000000FF',
                          light: '#FFFFFFFF'
                        }
                      }" tag="img" v-if="qrImageUrl"></vue-qrcode>
                      <div v-else>
                        <p>QR画像情報の取得に失敗しました。</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="pr-2 pl-2">
                    <div>
                      <span class="delivery-text">スマートフォンから画像の登録が完了したら、<br>「画像読み込み」ボタンを押してください。<br>このページに画像が反映されます。 </span>
                    </div>
                    <div class="pt-5 text-center">
                      <b-button  class="main-color text-light" @click="reloadImage">画像読み込み</b-button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 ml-5">
                    <span style="font-weight: 600;">商品が複数の種類ある場合は必ず任意欄を使って登録してください。<br>（例：ブーケが2種類の場合など）</span>
                  </div>
                </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="card-deck p-3" v-for="(image_info, index) in deliveryImageData()" :key="index">
                <div class="card mr-1 ml-1" v-for="(image, i) in image_info" :key="i">
                  <div class="card-header text-center p-0 card-sqr-gray tile-image-dev" v-if="image.filePath !== null">
                    <img :src="image.filePath" class="mw-100 tile-image-height" @click="clickImage(i + (index  * imageRowMaxNum))" >
                  </div>
                  <div class="card-header p-0" v-else>
                    <div class="tile-image-dev text-center pt-4" v-if="image.type !== '06'">
                      <p class="mb-1">{{image.typeName}}</p>
                      <b-icon icon="image" font-scale="2"></b-icon>
                      <p>no Image</p>
                    </div>
                    <div class="tile-image-dev text-center pt-5" v-else>
                      <b-icon icon="image" font-scale="2"></b-icon>
                      <p>no Image</p>
                    </div>
                  </div>
                  <div class="card-body p-0 small card-mlr">
                    <p class="card-title mb-1" v-if="image.type !== '06'">{{(i + 1) + (index * imageRowMaxNum)}}.{{image.typeName}}</p>
                    <p class="card-title mb-1" v-else>{{(i + 1) + (index * imageRowMaxNum)}}.{{image.typeName}}</p>
                    <p class="mb-1">任意</p>
                    <div class="row">
                      <div class="col">
                        <button v-if="image.filePath !== null" type="button" class="btn p-0 text-blue" @click="clickRotateImage(i + (index  * imageRowMaxNum))">
                          <b-icon icon="arrow-clockwise"></b-icon>
                        </button>
                        <button v-if="image.filePath === null" type="button" class="btn p-0" @click="clickRotateImage(i + (index  * imageRowMaxNum))" disabled>
                          <b-icon icon="arrow-clockwise"></b-icon>
                        </button>
                      </div>
                      <div class="text-right col text-nowrap pt-1">
                        <a class="text-blue" @click="clickUploadImage(i + (index  * imageRowMaxNum))" v-if="image.filePath === null">画像を登録</a>
                        <a class="text-blue" @click="clickDeleteImage(i + (index  * imageRowMaxNum))" v-else>画像クリア</a>
                        <input :id="'image-file-input-' + (i + (index  * imageRowMaxNum))" class="d-none" type="file" @change="uploadImage(i + (index  * imageRowMaxNum), $event)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                  <label for="comment">コメント({{comment.length}}/{{consts.commentMaxLength}}文字)</label>
                  <textarea class="form-control" id="comment" rows="3" v-model="comment" :maxlength="consts.commentMaxLength"></textarea>
              </div>
            </div>
          </b-overlay>
          <div class="col-sm-12">
            <div class="text-center mb-3">
              <b-button variant="outline-secondary" class="w-25" @click="backPage">制作案件一覧に戻る</b-button>
              <b-button class="main-color text-light w-25 ml-3" @click="regist">登録</b-button>
            </div>
          </div>
        </div>
      </form>
      <CommonModal title="" body="登録が完了しました" ref="commonModal"/>
    </div>
  </CommonLayout>
</template>
<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import DeliveredImageLoginInfoModel from '@/models/DeliveredImageLoginInfoModel'
import DeliveredImageModel from '@/models/DeliveredImageModel'
import imageCompression from 'browser-image-compression'

export default {
  name: 'DeliveryImage',
  components: {
    VueQrcode,
    CommonLayout,
    CommonModal,
    DeliveredImageLoginInfoModel,
    DeliveredImageModel
  },
  data () {
    return {
      overlayShow: false,
      weddingInfoOverlayShow: false,
      projectNumber: null,
      weddingInfos: {},
      imageInfos: [],
      deleteImageInfos: [],
      comment: '',
      qrImageUrl: '',
      imageRowMaxNum: 5,
      imageSelectNum: 0
    }
  },
  methods: {
    deliveryImageData () {
      if (!this.imageInfos) {
        return null
      }
      const length = Math.ceil(this.imageInfos.length / this.imageRowMaxNum)
      const images = new Array(length).fill().map((_, i) =>
        this.imageInfos.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )
      return images
    },
    backPage () {
      localStorage.setItem('isPageBack', JSON.stringify(true))
      this.$router.push('/project_list')
    },
    regist: async function () {
      if (this.comment.length > this.consts.commentMaxLength) {
        this.$refs.commonModal.confirmBox('コメントの文字数がオーバーしています')
        return false
      }

      this.overlayShow = true
      let reqData = {
        'projectNumber': this.weddingInfos.projectNumber
      }

      this.imageInfos.forEach(imageInfo => {
        if (reqData['regist'] === undefined) {
          reqData['regist'] = []
        }

        if (imageInfo.filePath) {
          reqData['regist'].push({
            'filePath': imageInfo.filePath,
            'imageType': imageInfo.type,
            'displayOrderNumber': imageInfo.displayOrder,
            'isAddFile': imageInfo.isAddFile
          })
        }
      })

      this.deleteImageInfos.forEach(deleteImageInfo => {
        if (reqData['delete'] === undefined) {
          reqData['delete'] = []
        }

        reqData['delete'].push(deleteImageInfo)
      })

      reqData['comment'] = this.comment

      DeliveredImageModel.postApi(this.$bvModal, reqData, (result) => {
        this.imageInfos = result['items'].map(elm => {
          elm['isAddFile'] = false
          return elm
        })
        this.deleteImageInfos = []
        this.$refs.commonModal.confirmBox('納品画像の登録が完了しました')
      },
      () => {
        this.overlayShow = false
      })
    },
    reloadImage: async function () {
      this.overlayShow = true
      this.weddingInfoOverlayShow = true
      const reqData = { 'projectNumber': this.projectNumber }
      DeliveredImageModel.getApi(this.$bvModal, reqData, (result) => {
        this.imageInfos = result['items'].map(elm => {
          elm['isAddFile'] = false
          return elm
        })
        this.weddingInfos = result['projectInfo']
        this.comment = result['deliveredCompleteComment']
      },
      () => {
        this.overlayShow = false
        this.weddingInfoOverlayShow = false
      })
    },
    setApiData: async function () {
      this.overlayShow = true
      this.weddingInfoOverlayShow = true
      const reqData = { 'projectNumber': this.projectNumber }

      DeliveredImageModel.getApi(this.$bvModal, reqData, (result) => {
        if ('items' in result) {
          this.imageInfos = result['items'].map(elm => {
            elm['isAddFile'] = false
            return elm
          })
        }
        this.weddingInfos = result['projectInfo']
        this.comment = result['deliveredCompleteComment']
      },
      () => {
        this.weddingInfoOverlayShow = false
      })

      const loginInfo = await DeliveredImageLoginInfoModel.getApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })
      this.qrImageUrl = loginInfo['qrImageUrl']
    },
    clickImage (index) {
      this.imageSelectNum = index
    },
    clickUploadImage (index) {
      document.getElementById('image-file-input-' + index).click()
    },
    clickDeleteImage (index) {
      if (!this.imageInfos[index].isAddFile) {
        this.deleteImageInfos.push(this.imageInfos[index].filePath)
      }
      this.imageInfos[index]['filePath'] = null
      this.imageInfos[index]['isAddFile'] = false
    },
    clickRotateImage: async function (index) {
      this.overlayShow = true

      const reqData = {
        'projectNumber': this.projectNumber,
        'imagePath': this.imageInfos[index].filePath,
        'imageType': this.imageInfos[index].type,
        'isAddFile': this.imageInfos[index].isAddFile
      }

      DeliveredImageModel.putApi(this.$bvModal, reqData, (result) => {
        this.imageInfos[index].filePath = result.images.imagePath
        this.clickImage(index)
      },
      () => {
        this.overlayShow = false
      })
    },
    uploadImage: async function (index, e) {
      if (typeof e.target.files[0] === 'undefined') {
        return false
      }

      const file = e.target.files[0]
      const extend = file.name.match(/[^.]+$/)[0]
      if (['PNG', 'png', 'JPG', 'JPEG', 'jpg', 'jpeg', 'GIF', 'gif'].includes(extend) === false) {
        this.$refs.commonModal.confirmBox('アップロード可能なファイル形式はjpeg・jpg・png・gifのみです。')
        return false
      }

      this.overlayShow = true

      const options = {
        maxSizeMB: 5,
        maxWidthOrHeight: 1280,
        useWebWorker: true
      }
      const compressedFile = await imageCompression(file, options)

      const dataUrl = await this.toDataUrl(compressedFile)

      const reqData = {
        'projectNumber': this.weddingInfos.projectNumber,
        'fileName': file.name,
        'imageType': this.imageInfos[index].type,
        'imageData': dataUrl.replace(/^.*,/, '')
      }

      DeliveredImageModel.uploadApi(this.$bvModal, reqData, (result) => {
        this.imageInfos[index].filePath = result.items.filePath
        this.imageInfos[index].isAddFile = true
        this.clickImage(index)
      },
      () => {
        this.overlayShow = false
      })
    },
    toDataUrl (file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
      })
    },
    handleResize () {
      if (window.innerWidth < 576) {
        this.imageRowMaxNum = 2
      } else if (window.innerWidth < 768) {
        this.imageRowMaxNum = 3
      } else if (window.innerWidth < 992) {
        this.imageRowMaxNum = 4
      } else {
        this.imageRowMaxNum = 5
      }
    }
  },
  mounted () {
    this.projectNumber = this.$route.params.projectNumber
    this.setApiData()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

}
</script>
<style>
.mw-100 {
  max-width: 100%;
}
.tile-image-dev {
  height: 140px;
}
.header-tile-image-dev {
  height: 300px;
}
.tile-image-height {
  max-height: 140px;
  height: auto;
}
.header-tile-image-height {
  max-height: 300px;
  height: auto;
}
.card-sqr-gray {
  border-radius: 0 !important;
  background-color: #ddd !important;
}
.card-mlr {
  margin: 0px 5px 0px 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/DeliveredImage.vue